/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SelfBatchDecisionRequest } from '../models/SelfBatchDecisionRequest';
import type { SelfDecisionRequest } from '../models/SelfDecisionRequest';
import type { SuccessResponse_ProcurementAnalysis_ } from '../models/SuccessResponse_ProcurementAnalysis_';
import type { SuccessResponse_ProcurementOrderDetail_ } from '../models/SuccessResponse_ProcurementOrderDetail_';
import type { SuccessResponse_ProcurementOverview_ } from '../models/SuccessResponse_ProcurementOverview_';
import type { SuccessResponse_ProcurementPage_ProcurementOrder__ } from '../models/SuccessResponse_ProcurementPage_ProcurementOrder__';
import type { SuccessResponse_ProcurementPage_ProcurementPriceFact__ } from '../models/SuccessResponse_ProcurementPage_ProcurementPriceFact__';
import type { SuccessResponse_ProcurementPage_ProcurementProduct__ } from '../models/SuccessResponse_ProcurementPage_ProcurementProduct__';
import type { SuccessResponse_ProcurementPage_ProcurementSupplier__ } from '../models/SuccessResponse_ProcurementPage_ProcurementSupplier__';
import type { SuccessResponse_ProcurementProductDetail_ } from '../models/SuccessResponse_ProcurementProductDetail_';
import type { SuccessResponse_ProcurementScope_ } from '../models/SuccessResponse_ProcurementScope_';
import type { SuccessResponse_SelfDecisionReceipt_ } from '../models/SuccessResponse_SelfDecisionReceipt_';
import type { SuccessResponse_SelfLedger_ } from '../models/SuccessResponse_SelfLedger_';
import type { SuccessResponse_SelfSources_ } from '../models/SuccessResponse_SelfSources_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProcurementService {
    /**
     * Self Sources Endpoint
     * @returns SuccessResponse_SelfSources_ Successful Response
     * @throws ApiError
     */
    public static selfSourcesEndpointApiV1ProcurementSelfSourcesGet({
        storeId,
        group = 'all',
        startDate,
        endDate,
    }: {
        storeId?: (number | null),
        group?: 'all' | 'direct',
        startDate?: (string | null),
        endDate?: (string | null),
    }): CancelablePromise<SuccessResponse_SelfSources_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/self-sources',
            query: {
                'store_id': storeId,
                'group': group,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Self Ledger Endpoint
     * @returns SuccessResponse_SelfLedger_ Successful Response
     * @throws ApiError
     */
    public static selfLedgerEndpointApiV1ProcurementSelfLedgersLedgerIdGet({
        ledgerId,
        storeId,
        startDate,
        endDate,
    }: {
        ledgerId: string,
        storeId: number,
        startDate: string,
        endDate: string,
    }): CancelablePromise<SuccessResponse_SelfLedger_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/self-ledgers/{ledger_id}',
            path: {
                'ledger_id': ledgerId,
            },
            query: {
                'store_id': storeId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Self Ledger Confirm Endpoint
     * @returns SuccessResponse_SelfDecisionReceipt_ Successful Response
     * @throws ApiError
     */
    public static selfLedgerConfirmEndpointApiV1ProcurementSelfLedgersLedgerIdDecisionsPost({
        ledgerId,
        requestBody,
    }: {
        ledgerId: string,
        requestBody: (SelfDecisionRequest | SelfBatchDecisionRequest),
    }): CancelablePromise<SuccessResponse_SelfDecisionReceipt_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/procurement/self-ledgers/{ledger_id}/decisions',
            path: {
                'ledger_id': ledgerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Scope Endpoint
     * @returns SuccessResponse_ProcurementScope_ Successful Response
     * @throws ApiError
     */
    public static scopeEndpointApiV1ProcurementScopeGet({
        storeId,
        group = 'all',
    }: {
        storeId?: (number | null),
        group?: 'all' | 'direct',
    }): CancelablePromise<SuccessResponse_ProcurementScope_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/scope',
            query: {
                'store_id': storeId,
                'group': group,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Analysis Endpoint
     * @returns SuccessResponse_ProcurementAnalysis_ Successful Response
     * @throws ApiError
     */
    public static analysisEndpointApiV1ProcurementAnalysisGet({
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        trendMode = 'week',
    }: {
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        trendMode?: 'week' | 'rolling',
    }): CancelablePromise<SuccessResponse_ProcurementAnalysis_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/analysis',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'trend_mode': trendMode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Overview Endpoint
     * @returns SuccessResponse_ProcurementOverview_ Successful Response
     * @throws ApiError
     */
    public static overviewEndpointApiV1ProcurementOverviewGet({
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
    }: {
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
    }): CancelablePromise<SuccessResponse_ProcurementOverview_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/overview',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Products Endpoint
     * @returns SuccessResponse_ProcurementPage_ProcurementProduct__ Successful Response
     * @throws ApiError
     */
    public static productsEndpointApiV1ProcurementProductsGet({
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        search = '',
        category,
        sort = 'amount',
        risingOnly = false,
        priceFilter = 'all',
        page = 1,
        pageSize = 25,
    }: {
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        search?: string,
        category?: (string | null),
        sort?: 'amount' | 'change' | 'price' | 'impact' | 'magnitude',
        risingOnly?: boolean,
        priceFilter?: 'all' | 'up' | 'down' | 'flat' | 'incomparable',
        page?: number,
        pageSize?: number,
    }): CancelablePromise<SuccessResponse_ProcurementPage_ProcurementProduct__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/products',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'search': search,
                'category': category,
                'sort': sort,
                'rising_only': risingOnly,
                'price_filter': priceFilter,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Product Detail Endpoint
     * @returns SuccessResponse_ProcurementProductDetail_ Successful Response
     * @throws ApiError
     */
    public static productDetailEndpointApiV1ProcurementProductsDetailGet({
        startDate,
        endDate,
        goodsSn,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        goodsSpecText,
        unitNameCn,
    }: {
        startDate: string,
        endDate: string,
        goodsSn: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        goodsSpecText?: (string | null),
        unitNameCn?: (string | null),
    }): CancelablePromise<SuccessResponse_ProcurementProductDetail_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/products/detail',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'goods_sn': goodsSn,
                'goods_spec_text': goodsSpecText,
                'unit_name_cn': unitNameCn,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Price Records Endpoint
     * @returns SuccessResponse_ProcurementPage_ProcurementPriceFact__ Successful Response
     * @throws ApiError
     */
    public static priceRecordsEndpointApiV1ProcurementProductsPricesGet({
        startDate,
        endDate,
        goodsSn,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        goodsSpecText,
        unitNameCn,
        side = 'both',
        day,
        page = 1,
        pageSize = 25,
    }: {
        startDate: string,
        endDate: string,
        goodsSn: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        goodsSpecText?: (string | null),
        unitNameCn?: (string | null),
        side?: 'current' | 'previous' | 'both',
        day?: (string | null),
        page?: number,
        pageSize?: number,
    }): CancelablePromise<SuccessResponse_ProcurementPage_ProcurementPriceFact__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/products/prices',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'goods_sn': goodsSn,
                'goods_spec_text': goodsSpecText,
                'unit_name_cn': unitNameCn,
                'side': side,
                'day': day,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Orders Endpoint
     * @returns SuccessResponse_ProcurementPage_ProcurementOrder__ Successful Response
     * @throws ApiError
     */
    public static ordersEndpointApiV1ProcurementOrdersGet({
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        search = '',
        status = 'accepted',
        side = 'current',
        day,
        orderDates,
        goodsSn,
        goodsSpecText,
        unitNameCn,
        supplySubjectId,
        supplierId,
        supplySubjectType,
        strictSupplyIdentity = false,
        multipleOnly = false,
        page = 1,
        pageSize = 25,
    }: {
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        search?: string,
        status?: 'accepted' | 'draft' | 'all',
        side?: 'current' | 'previous' | 'both',
        day?: (string | null),
        orderDates?: (string | null),
        goodsSn?: (string | null),
        goodsSpecText?: (string | null),
        unitNameCn?: (string | null),
        supplySubjectId?: (string | null),
        supplierId?: (string | null),
        supplySubjectType?: (string | null),
        strictSupplyIdentity?: boolean,
        multipleOnly?: boolean,
        page?: number,
        pageSize?: number,
    }): CancelablePromise<SuccessResponse_ProcurementPage_ProcurementOrder__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/orders',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'search': search,
                'status': status,
                'side': side,
                'day': day,
                'order_dates': orderDates,
                'goods_sn': goodsSn,
                'goods_spec_text': goodsSpecText,
                'unit_name_cn': unitNameCn,
                'supply_subject_id': supplySubjectId,
                'supplier_id': supplierId,
                'supply_subject_type': supplySubjectType,
                'strict_supply_identity': strictSupplyIdentity,
                'multiple_only': multipleOnly,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Order Detail Endpoint
     * @returns SuccessResponse_ProcurementOrderDetail_ Successful Response
     * @throws ApiError
     */
    public static orderDetailEndpointApiV1ProcurementOrdersOrderIdGet({
        orderId,
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
    }: {
        orderId: number,
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
    }): CancelablePromise<SuccessResponse_ProcurementOrderDetail_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/orders/{order_id}',
            path: {
                'order_id': orderId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Suppliers Endpoint
     * @returns SuccessResponse_ProcurementPage_ProcurementSupplier__ Successful Response
     * @throws ApiError
     */
    public static suppliersEndpointApiV1ProcurementSuppliersGet({
        startDate,
        endDate,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        search = '',
        page = 1,
        pageSize = 25,
    }: {
        startDate: string,
        endDate: string,
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        search?: string,
        page?: number,
        pageSize?: number,
    }): CancelablePromise<SuccessResponse_ProcurementPage_ProcurementSupplier__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/suppliers',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'search': search,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportEndpointApiV1ProcurementExportGet({
        startDate,
        endDate,
        view,
        storeId,
        group = 'all',
        diagnosisStoreId,
        basis = 'observed',
        currentDates,
        previousDates,
        search = '',
        status = 'accepted',
        side = 'current',
        day,
        orderDates,
        goodsSn,
        goodsSpecText,
        unitNameCn,
        supplySubjectId,
        supplierId,
        supplySubjectType,
        strictSupplyIdentity = false,
        multipleOnly = false,
        page = 1,
        pageSize = 25,
        category,
        productSort = 'amount',
        risingOnly = false,
        priceFilter = 'all',
        storeSort = 'change',
        storeChangeFilter = 'all',
    }: {
        startDate: string,
        endDate: string,
        view: 'stores' | 'products' | 'suppliers' | 'orders' | 'quantity_price' | 'categories',
        storeId?: (number | null),
        group?: 'all' | 'direct',
        diagnosisStoreId?: (number | null),
        basis?: 'observed' | 'comparison',
        currentDates?: (string | null),
        previousDates?: (string | null),
        search?: string,
        status?: 'accepted' | 'draft' | 'all',
        side?: 'current' | 'previous' | 'both',
        day?: (string | null),
        orderDates?: (string | null),
        goodsSn?: (string | null),
        goodsSpecText?: (string | null),
        unitNameCn?: (string | null),
        supplySubjectId?: (string | null),
        supplierId?: (string | null),
        supplySubjectType?: (string | null),
        strictSupplyIdentity?: boolean,
        multipleOnly?: boolean,
        page?: number,
        pageSize?: number,
        category?: (string | null),
        productSort?: 'amount' | 'change' | 'price' | 'impact' | 'magnitude',
        risingOnly?: boolean,
        priceFilter?: 'all' | 'up' | 'down' | 'flat' | 'incomparable',
        storeSort?: 'change' | 'name' | 'ratio' | 'amount',
        storeChangeFilter?: 'all' | 'flat-flat' | 'flat-up' | 'flat-down' | 'up-flat' | 'down-flat' | 'up-down' | 'down-up' | 'both-up-same' | 'both-up-p' | 'both-up-s' | 'both-down-same' | 'both-down-s' | 'both-down-p',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/procurement/export',
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'store_id': storeId,
                'group': group,
                'diagnosis_store_id': diagnosisStoreId,
                'basis': basis,
                'current_dates': currentDates,
                'previous_dates': previousDates,
                'search': search,
                'status': status,
                'side': side,
                'day': day,
                'order_dates': orderDates,
                'goods_sn': goodsSn,
                'goods_spec_text': goodsSpecText,
                'unit_name_cn': unitNameCn,
                'supply_subject_id': supplySubjectId,
                'supplier_id': supplierId,
                'supply_subject_type': supplySubjectType,
                'strict_supply_identity': strictSupplyIdentity,
                'multiple_only': multipleOnly,
                'page': page,
                'page_size': pageSize,
                'view': view,
                'category': category,
                'product_sort': productSort,
                'rising_only': risingOnly,
                'price_filter': priceFilter,
                'store_sort': storeSort,
                'store_change_filter': storeChangeFilter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
